import { Link } from 'react-router-dom';
import { Emblem } from '../components/Emblem';
import { OrderLookupForm } from './OrderLookupForm';

export function OrderLookupPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 24,
      }}
    >
      <div style={{ maxWidth: 520, width: '100%', textAlign: 'center' }}>
        <Emblem size={140} style={{ margin: '0 auto' }} />
        <h1 className="display" style={{ fontSize: 32, marginTop: 18, color: 'var(--orange)' }}>
          TWOJE ZAMÓWIENIE
        </h1>
        <p style={{ marginTop: 12, fontSize: 14, color: 'rgba(var(--shop-muted-rgb),.75)' }}>
          Numer zamówienia znajdziesz w mailu z potwierdzeniem.
        </p>
        <OrderLookupForm />
        <div style={{ marginTop: 20, fontSize: 12 }}>
          <Link to="/" style={{ color: 'var(--orange)' }}>
            ← Wróć do sklepu
          </Link>
        </div>
      </div>
    </div>
  );
}
